import { useState, useCallback } from 'react';

export default function useBoolState(initialState?: boolean): [boolean, () => void, () => void] {
  const [boolState, setBoolState] = useState(initialState ?? false);
  const setTrue = useCallback(() => setBoolState(true), []);
  const setFalse = useCallback(() => setBoolState(false), []);

  return [boolState, setTrue, setFalse];
}
